<template>
    <div class="cc-carrier" v-if="shouldCarrierBeShown" @click="setCarrier(carrier)">
        <div class="cc-carrier__selector">
            <div class="cc-selector cc-selector--radio cc-selector--medium" v-bind:class="{'cc-active': isCarrierSelectedCarrier}"></div>
        </div>
        <div class="cc-carrier__thumbnail" v-if="carrier.img">
            <img :src="carrier.img" :alt="carrier.name" class="cc-carrier__image"/>
        </div>
        <div class="cc-carrier__main" v-bind:class="{'cc-thumbnail-exists': carrier.img}">
            <div class="cc-carrier__title">{{ carrier.name }}</div>
            <div class="cc-carrier__delay">{{ carrier.delay }}</div>
            <div class="cc-carrier__branch" v-if="carrier.module === 'packetery'">
                {{ packetery.id ? packetery.name : ''}}
                <button class="cc-button cc-button--delivery-branch" @click.stop="showPacketeryWidget(carrier)">{{ packetery.id ? translations['Change'] : translations['Select branch'] }}</button>
            </div>
            <div class="cc-carrier__branch" v-if="carrier.module === 'shaim_baliknapostu'">
                <post-office-package :carrier="carrier"/>
            </div>
        </div>
        <div class="cc-carrier__prices">
            <div class="cc-price cc-price--carrier">{{ displayCarrierPrice }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import PostOfficePackage from "./PostOfficePackage";

    export default {
        components: {
            PostOfficePackage,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCarrier: state => state.selectedCarrier,
                packetery: state => state.packetery,
            }),
            shouldCarrierBeShown: function () {
                if (this.selectedCarrier === null || this.selectedCarrier === '') {
                    return true;
                }

                return this.carrier.id_carrier === this.selectedCarrier;
            },
            isCarrierSelectedCarrier: function () {
                return this.carrier.id_carrier === this.selectedCarrier;
            },
            displayCarrierPrice: function () {
                return this.carrier.free ? this.translations['Free'] : this.carrier.formattedPrices.price;
            },
        },
        methods: {
            setCarrier: function (carrier) {
                const that = this;

                this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(function () {
                    if (carrier.module === 'packetery') {
                        that.showPacketeryWidget(carrier);
                    }

                    document.querySelector('.cc-theme--globalmoto__carriers').scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            },
            getPacketery: function () {
                const filtered = this.carriers.filter(item => item.module === 'packetery');

                if (filtered.length === 1) {
                    return filtered[0];
                }

                return null;
            },
            showPacketeryWidget: function (carrier) {
                Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
                    if (item === null) {
                        return this.$store.commit('SET_PACKETERY', {
                            id: null,
                            name: null,
                            currency: null,
                        });
                    }

                    this.$store.dispatch('UPDATE_PACKETERY', {
                        id: item.id,
                        name: item.name,
                        currency: item.currency,
                    });
                });
            },
        },
        mounted() {
            const loadPacketeryScript = () => {
                if (this.carriers === null) {
                    setTimeout(loadPacketeryScript, 100);
                }

                if (this.getPacketery) {
                    const packeteryApi = document.createElement('script');
                    packeteryApi.setAttribute('src', 'https://widget.packeta.com/www/js/library.js');
                    document.head.appendChild(packeteryApi);
                }
            };

            loadPacketeryScript();
        },
        name: 'Carrier',
        props: [
            'carrier'
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/carrier";
</style>
